<template>
  <modal
    name="categoriaEdit"
    height="auto"
    width="900"
    :scrollable="true"
    :clickToClose="true"
  >
    <div class="modalbox">
      <div class="modalbox-content">
        <div class="row">
          <ul class="tabs">
            <li class="tab-active">
              <a>Editando Categoria</a>
            </li>
          </ul>
        </div>
        <div class="form">
          <div class="row">
            <div class="col-1-4">
              <div class="form-group">
                <label for>ID ERP</label>
                <select
                  type="text"
                  v-model="item.idErp"
                  class="form-control"
                  @change="fillPredefinedInfo()"
                  disabled
                >
                  <option
                    v-for="menu in menusOption"
                    :value="menu.idErp"
                    v-bind:key="menu.idErp"
                  >
                    {{ menu.idErp }} - {{ menu.titulo }}
                  </option>
                </select>
                <div class="message">
                  {{ validation.firstError("item.idErp") }}
                </div>
              </div>
            </div>
            <div class="col-1-4">
              <div class="form-group">
                <label for>Título</label>
                <input
                  type="text"
                  v-model="item.titulo"
                  class="form-control"
                  disabled
                />
                <div class="message">
                  {{ validation.firstError("item.titulo") }}
                </div>
              </div>
            </div>
            <div class="col-1-4">
              <div class="form-group">
                <label for>Ordem</label>
                <input
                  type="number"
                  v-model="item.ordem"
                  class="form-control"
                  :min="0"
                />
                <div class="message">
                  {{ validation.firstError("item.ordem") }}
                </div>
              </div>
            </div>
            <div class="col-1-4">
              <div class="form-group">
                <label for>Visível</label>
                <select
                  type="number"
                  v-model="item.visivel"
                  class="form-control"
                >
                  <option :value="true">Sim</option>
                  <option :value="false">Não</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <div class="form-group">
                <label for>Link</label>
                <input
                  type="text"
                  v-model="item.link"
                  class="form-control"
                  disabled
                />
                <div class="message">
                  {{ validation.firstError("item.link") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-actions">
            <button
              :class="{
                'button button-success button-lg': true,
                'button-disabled': validation.hasError(),
              }"
              v-on:click="handleSubmit"
            >
              Alterar
            </button>
            <button class="button button-lg" v-on:click="close">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import SimpleVueValidation from "simple-vue-validator";
import { getImage } from "../../helpers/utils";
const Validator = SimpleVueValidation.Validator;

export default {
  name: "categoriaEdit",
  props: ["item", "update", "close", "menusOption"],
  data() {
    return {
      pdfTitulo: "",
    };
  },
  validators: {
    "item.titulo": function (value) {
      return Validator.value(value).required();
    },
    "item.idErp": function (value) {
      return Validator.value(value).required();
    },
    "item.link": function (value) {
      return Validator.value(value).required();
    },
    "item.ordem": function (value) {
      return Validator.value(value).required().digit();
    },
  },
  methods: {
    fillPredefinedInfo() {
      const menu = this.menusOption.find((menu) => menu.id === this.item.idErp);
      this.item.titulo = menu.desc;
      this.item.link = menu.slug;
      this.item.ordem = menu.ordem;
    },
    handleSubmit() {
      this.$validate().then((success) => {
        console.log("success", success);
        if (success) {
          this.update();
        }
      });
    },
    getImage: getImage,
  },
};
</script>


// WEBPACK FOOTER //
// src/views/Categorias/Edit.vue